import { z } from 'zod';

const completedDataset = z.object({
  status: z.literal('completed'),
  data: z.object({
    rows: z.array(z.array(z.unknown())),
    cols: z.array(z.object({ name: z.string() })),
    rows_truncated: z.literal(false).optional(),
  }),
  rows_truncated: z.literal(false).optional(),
});

/** Strict mode prevents failed or incomplete datasets masquerading as empty inventory. */
export function reportDatasetRows(
  response: unknown,
  requireCompleted = false,
): Array<Record<string, unknown>> {
  const parsed = requireCompleted ? completedDataset.parse(response) : response;
  const data = (parsed as { data?: { rows?: unknown[][]; cols?: Array<{ name: string }> } })?.data;
  const rows = data?.rows ?? [];
  const names = (data?.cols ?? []).map(col => col.name);
  if (
    requireCompleted &&
    (new Set(names).size !== names.length || rows.some(row => row.length !== names.length))
  ) {
    throw new Error('Incomplete dataset columns. Please retry.');
  }
  return rows.map(row => {
    const obj: Record<string, unknown> = {};
    names.forEach((name, index) => {
      obj[name] = row[index];
    });
    return obj;
  });
}
